import { Component } from '@angular/core';

@Component({
  selector: 'app-swiss-made-footer',
  templateUrl: './swiss-made-footer.component.html',
  styleUrls: ['./swiss-made-footer.component.scss'],
  standalone: false
})
export class SwissMadeFooterComponent {
  showGuarantee = false;
  appLocation: string;

  constructor() {
    const { host } = window.location;
    const hostArray = host.split('.');
    if (hostArray[0].includes('localhost')) {
      // default domain is CH
      this.appLocation = 'ch';
    } else {
      this.appLocation = hostArray[hostArray.length - 1];
    }
  }

  toggleGuaranteeModal(): void {
    this.showGuarantee = !this.showGuarantee;
  }
}
